import styled, { css } from 'styled-components'
import DndComponent from './dnd'

export const Container = styled.div<{ backgroundColor?: string; disabled: boolean }>`
    background: ${({ backgroundColor }) => backgroundColor};
    border-radius: inherit;
    height: 100%;
    position: relative;
    user-select: none;
    width: 100%;

    ${({ disabled }) =>
        disabled &&
        css`
            opacity: 0.5;
            pointer-events: none;
        `}
`

export const Dnd = styled(DndComponent)`
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    touch-action: pan-x;
    width: 100%;
`
